namespace $.$$ {

	export class $shm_hitalama_page extends $.$shm_hitalama_page {


	}

}
